import React from 'react'
import PropTypes from 'prop-types'
import { InfinitySpin } from 'react-loader-spinner'
import '../../assets/scss/loading_overlay.scss'

export const LoadingOverlay = ({ isOpen = false }) => {
  return (
    <div className={`loading-overlay ${isOpen ? 'open' : ''}`}>
      <div className="loader">
        <InfinitySpin width="200" color="#ea5a5a" />
      </div>
    </div>
  )
}

LoadingOverlay.propTypes = {
  isOpen: PropTypes.bool,
}

LoadingOverlay.defaultProps = {
  isOpen: false,
}
